import React from 'react';
import _get from 'lodash.get';
import Layout from 'components_v2/desktop/Layout';
import AuthorListing from 'routes/toiplusauthor/components/AuthorListing/AuthorListing';

// import { commonHeadScriptsMobile } from 'helpers/scripts/headScripts';
import { getSiteConfig } from 'reduxUtils/modules/common';
import { loadLayoutDataTOIP } from 'reduxUtils/modules_v2/layout';
import { loadAuthorData } from 'routes/toiplusauthor/redux';
import {
  getSearchKeyword,
  preloadLeadImage,
} from 'routes/toiplussection/ToiplusSectionHelper';

const pageName = 'prime_hplist';

async function action(context) {
  const dataPromiseArray = [];
  const localParams = { 0: context.path };
  // existing state
  let state = context.store.getState();
  const cd8 = '';
  const isAppView = state.isFrmapp;
  const isWapView = false;
  const urlPath = context.pathname;
  const isPrime = !!state.isPrime;
  const searchKeyword = getSearchKeyword(urlPath);
  const newParams = {
    ...localParams,
    fullPath: urlPath,
    isWapView,
    curpg: 1,
    skipSubSections: true,
    isAppView,
    searchKeyword,
    isPrime,
  };

  // Data calls start

  // Layout
  if (!isAppView && (!state.header.data || !state.footer_v2.data)) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataTOIP(newParams)),
    );
  }

  // Content
  if (!state.toiplusauthor.sections) {
    dataPromiseArray.push(context.store.dispatch(loadAuthorData(newParams)));
  }

  // Data calls end

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  if (typeof window !== 'undefined') {
    window.categoryForGA = 'TOI Plus';
  }

  // get updated state
  state = context.store.getState();
  let status = 200;
  const title = 'Get Latest News Updates from Times Of India';
  // const dataAvailable = true;
  const authorName = _get(state.toiplusauthor.seo, 'h1', searchKeyword);

  const checkSectionItems = () =>
    state.toiplusauthor.sections?.some(
      sectionItem =>
        sectionItem.tn === 'sectionlisting' && sectionItem?.items?.length > 0,
    );
  const dataAvailable = checkSectionItems();
  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  const sectionsArray = state.toiplusauthor?.sections?.map(sectionItem => {
    if (sectionItem.tn === 'sectionlisting' && sectionItem?.items?.length > 0) {
      return sectionItem?.items;
    }
    return null;
  });
  const preloadStories = dataAvailable
    ? Array.isArray(sectionsArray) &&
      sectionsArray.length > 0 &&
      sectionsArray.filter(
        item =>
          item?.isLead === 'featured' || item?.isSubLead === 'subfeatured',
      )
    : [];
  const { showPreload, imageInfo } = preloadLeadImage(preloadStories);

  const getComponent = pageTitle => {
    if (!dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com/toi-plus">here</a> to
          browse TOI Plus Content
        </div>
      );
    }

    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        rhs={false}
        isPrime={state.isPrime}
        hideBreadcrumAtBottom
        hideGetAppWidget
        hideGetAppBtn
        skipAds
        hideAdCude
        headerClass="fix-header-zero"
        pageType="toiplusauthorpage"
        layoutClass="toipLayout toiplusauthorpage"
        toipLayout
      >
        <h1>{authorName}</h1>
        <AuthorListing
          params={newParams}
          isWapView={false}
          authorName={authorName}
          urlPath={urlPath}
        />
      </Layout>
    );
  };
  // const gtmIDForOptimisely = ['GTM-KCRX3PN'];
  const authorPageSeo = state.toiplusauthor?.seo || {};
  return {
    chunks: ['toiplusauthordesktop'],
    title,
    seoData: {
      ...authorPageSeo,
      schema: state.toiplusauthor?.schema || [],
    },
    status,
    component: getComponent(title),
    maxAge: 1800,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    preconnectDomains: [],
    // gtmIDList: gtmIDForOptimisely,
    headTags: [],
    skipColumbiaScript: true,
    skipImaScript: true,
    skipPubmaticScript: true,
    skipPageViewGAOnLoad: true,
    isPrime: state.isPrime,
    TOIPlusRoute: true,
    skipRouteAds: true,
    showPreload,
    imageInfo,
  };
}

export default action;
